import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { Button } from 'dibs-elements/exports/Button';

// Helpers
import { copy, modals, mutations } from '../../constants';

// Styles
import styles from './styles/ClickToConfirmModal.scss';

const ClickToConfirmModal = ({
    closeModal,
    itemMutations,
    folderMutations,
    modalOpen,
    openModalType,
    followingMutations,
}) => {
    let type;

    if (openModalType === modals.REMOVE_FOLLOWING) {
        type = 'Following';
    } else if (openModalType === modals.REMOVE_FOLDERS) {
        type = 'Folders';
    } else {
        type = 'Items';
    }

    const remove = () => {
        if (openModalType === modals.REMOVE_FOLDERS) {
            folderMutations(mutations.types.REMOVE);
        } else if (openModalType === modals.REMOVE_FOLLOWING) {
            followingMutations({ action: mutations.types.REMOVE });
        } else {
            itemMutations({ action: mutations.types.REMOVE });
        }
    };

    return (
        <ModalContainer
            dataTn="portfolio-remove"
            onClose={closeModal}
            isOpen={modalOpen}
            modalPosition="center"
        >
            <ModalCloseButton onClick={closeModal} />
            <BarHeader dataTn="portfolio-remove" title={copy[`remove${type}`].MODAL_TITLE} />
            <ModalBody dataTn="portfolio-remove">
                <div className={styles.description}>{copy[`remove${type}`].MODAL_DESCRIPTION}</div>
                <div className={styles.submit}>
                    <Button
                        dataTn="portfolio-remove-submit"
                        fullWidth
                        onClick={remove}
                        size="large"
                        style="primary"
                    >
                        {copy[openModalType].SUBMIT}
                    </Button>
                </div>
            </ModalBody>
        </ModalContainer>
    );
};

ClickToConfirmModal.propTypes = {
    closeModal: PropTypes.func,
    folderMutations: PropTypes.func,
    itemMutations: PropTypes.func,
    followingMutations: PropTypes.func,
    modalOpen: PropTypes.bool,
    openModalType: PropTypes.string,
};

const mapStateToProps = state => {
    return {
        openModalType: state.favorites.modalState.openModalType,
    };
};

export default connect(mapStateToProps)(ClickToConfirmModal);
